import { Directive, TemplateRef, input } from '@angular/core';

@Directive({
    selector: '[keyTemplate]',
    standalone: true,
    host: {}
})
export class KeyTemplateDirective {

    name = input.required<string>({ 'alias': 'keyTemplate' });

    constructor(public template: TemplateRef<unknown>) { }

    getType(): string {
        return this.name()!;
    }
}
